import { Subscription } from "@rails/actioncable";
import { cableStore } from "@/store/typed";

class CableCycleAdapter {
  received: (data: any) => void;

  constructor(onResponse: (data: any) => void) {
    this.received = onResponse;
  }
}

export default class GenericCable {
  channelName?: string;

  constructor(channelName: string) {
    this.channelName = channelName;
  }

  subscription: (Subscription & CableCycleAdapter) | null = null;

  onResponse!: (data: any) => void;

  close() {
    cableStore.disconnect();
  }

  async open(options?: any) {
    let params = {
      channel: this.channelName || "",
    };
    if (options) {
      params = Object.assign({}, params, options);
    }
    const handler = new CableCycleAdapter(this.onResponse);

    this.subscription = await cableStore.subscribe({
      params,
      handler,
    });
  }
}
